<template>
  <v-flex>
    <v-card>
      <pi-progress v-if="progress"></pi-progress>

      <v-list subheader>
        <v-subheader>Ostatnie zmiany</v-subheader>
        <v-subheader v-if="changes.length < 1">Brak zmian</v-subheader>
        <v-list-tile v-for="change in changes" :key="change.id" avatar>
          <pi-avatar :user="change.User" list="true"></pi-avatar>
          <v-list-tile-content>
            <v-list-tile-title>{{ change.text }}</v-list-tile-title>
            <v-list-tile-sub-title>{{ change.createdAt | humanDate }}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>

      <v-card-actions>
        <v-btn flat @click="changeOffset(-1)" :disabled="progress" v-if="offset > 0">Zobacz nowsze</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          flat
          @click="changeOffset(1)"
          :disabled="progress"
          v-if="changes.length == 5"
        >Zobacz starsze</v-btn>
      </v-card-actions>
    </v-card>
    <pi-snackbar :color="snackbarColor" :snackbar.sync="snackbar" :message="snackMessage"></pi-snackbar>
  </v-flex>
</template>

<script>
export default {
  props: ["id"],
  data: () => ({
    progress: false,
    snackbar: false,
    snackbarColor: "error",
    snackMessage: "",
    changes: [],
    offset: 0
  }),
  methods: {
    async getData() {
      this.progress = true;
      const response = await this.Api.send(
        "get",
        `/filetreechanges/${this.id}/${this.offset * 5}`
      );
      this.progress = false;
      if (response.status) {
        this.changes = response.changes;
        return;
      }
      this.showErrors(response.message);
    },
    async showErrors(message) {
      this.snackMessage = message;
      this.snackbarColor = "error";
      this.snackbar = true;
    },
    async changeOffset(offset) {
      if (this.progress || this.offset + offset < 0) return;
      this.offset += offset;
      this.getData();
    }
  },
  async mounted() {
    await this.getData();
  }
};
</script>